export enum SortDirection {
  Asc = 1,
  Desc = -1,
  Default = 0,
}
